import { GetDailyTradeVolumeBrlReponse } from "@services/models/Analytics/GetDailyTradeVolumeBrl";
import { AxiosInstance } from "axios";
import { createApiClient } from "../api/createApiClient";

class AnalyticsApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }

  public async getDailyTradeVolumeBRL(): Promise<GetDailyTradeVolumeBrlReponse> {
    try {
      const response = await this.api.get<GetDailyTradeVolumeBrlReponse>(
        "/analyticsDashboard/getDailyTradeVolumeBRL"
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const analyticsApiServices = new AnalyticsApiService();
